export default "__VITE_ASSET__DfMNIh_k__"